import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Autocomplete,
  Button,
  CardHeader,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  TextField,
} from "@mui/material";
import logo from "./logo.png";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useToast from "../hooks/useToast";
import { TYPE_NOTIFICATION } from "./utils/NotificationBull";
import Formservice from "../service/Formservice";
import NB from "./reusable/NB";
import Identifiant from "./reusable/Identifiant";
import { Info } from "@mui/icons-material";
import { TYPE_STAGE } from "./utils/Extre_data";
import dayjs from "dayjs";

const Disponibilite = () => {
  const ref = localStorage.getItem("ref");
  const parts = ref.split("_");
  const prefix = parts[0];
  const [identif, setIdentif] = useState({});
  const [directionsFid, setDirectionsFid] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({
    date_dispo_debut_error: null,
    date_dispo_fin_error: null,
    type_stage_error: null,
    direction_souhaiter_error: null,
  });

  const { Toast, showToast } = useToast();

  const handleFetchIdentite = () => {
    setLoading(true);
    Formservice.details(ref)
      .then((result) => {
        if (result && result.data) {
          setIdentif(result.data);
          /*   if (!["Cons_int"].includes(result.data.desc)) {
            navigate("/fichier");
          } */
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCheckError = () => {
    setFormErrors({
      date_dispo_debut_error:
        identif.toujours_dispo === "0" &&
        !identif.date_dispo_debut &&
        ["Stagiaire", "Candidature Spontané"].includes(identif.poste)
          ? "Date de debut requise"
          : null,
      date_dispo_fin_error:
        !identif.date_dispo_fin &&
        identif.toujours_dispo === "0" &&
        ["Stagiaire", "Candidature Spontané"].includes(identif.poste)
          ? "Date de fin requise"
          : dayjs(identif.date_dispo_debut).isAfter(
                dayjs(identif.date_dispo_fin)
              )
            ? "La date de fin doit être après la date de debut"
            : null,
      type_stage_error:
        !identif.type_stage && identif.poste === "Stagiaire"
          ? "Type de stage requis"
          : null,
      direction_souhaiter_error:
        !identif.direction_souhaiter /* && identif.poste === "Stagiaire" */
          ? "Direction souhaitée requise "
          : null,
    });
    return Object.values(formErrors).every((item) => item === null);
  };

  const handlePrevious = () => {
    navigate("/autrecompetence");
  };

  const handleEditIdentity = () => {
    let identity = identif;
    delete identity.nom;
    Formservice.editDispoAndTypeStage(identif).then((res) => {
      if (res && res.data) {
        if (res.success) {
          showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
          navigate("/fichier");
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, res.message);
        }
      }
    });
  };

  const handleFetchDirections = () => {
    Formservice.directionListe().then((res) => {
      if (res && res.data) {
        setDirectionsFid(res.data);
      }
    });
  };

  const handleSaveAll = () => {
    setLoading(true);
    if (handleCheckError()) {
      handleEditIdentity();
    } else {
      showToast(TYPE_NOTIFICATION.ERROR, "Veuillez verifier les champs");
    }
  };

  useEffect(() => {
    handleFetchIdentite();
    handleFetchDirections();
  }, []);

  useEffect(() => {
    handleCheckError();
  }, [identif]);

  return (
    <>
      <Toast />
      <Grid
        container
        display={"flex"}
        height={"100vh"}
        alignItems={"center"}
        justifyContent="center"
      >
        <Grid
          item
          xs={12}
          md={10}
          lg={7}
          minHeight={"90vh"}
          borderRadius={"20px"}
          // border={"3px #0747a1 solid "}
          border={"2px rgba(11, 93, 208,0.5) solid "}
          boxShadow="0px 4px 10px rgba(7,71,161,0.4)"
          display={"flex"}
          flexDirection={"column"}
          p={2.5}
        >
          <Grid item>
            <Grid container item xs={12} justifyContent={"center"}>
              <img
                src={logo}
                className="App-logo"
                alt="logo"
                style={{
                  maxWidth: "75px",
                  maxHeight: "75px",
                  // marginLeft: "40%",
                  // display: window.innerWidth <= 600 ? "block" : "none",
                }}
              />
            </Grid>
            <h1 style={{ marginBottom: "10px", textAlign: "center" }}>
              Disponibilité & choix de direction/antenne
            </h1>
          </Grid>
          <Grid item flexGrow={1} display={"flex"} flexDirection={"column"}>
            <Grid container>
              <Grid item xs={12} md={6}>
                <Identifiant identif={identif} prefix={prefix} refer={ref} />
              </Grid>
              <Grid item xs={12} md={6} style={{ color: "red" }}>
                <NB
                  texts={[
                    "Tous les champs avec * sont obligatoires",
                    "Veuillez cliquer sur suivant pour passer au suivant.",
                  ]}
                />
              </Grid>
            </Grid>
            <Grid
              container
              display={"flex"}
              flexDirection={"column"}
              flexGrow={1}
            >
              <Grid
                item
                flexGrow={0.5}
                sx={{
                  display: ["Stagiaire", "Candidature Spontané"].includes(
                    identif.poste
                  )
                    ? "block"
                    : "none",
                }}
              >
                <CardHeader
                  title={"Date de disponibilité *"}
                  subheader={
                    <Alert variant="standard" icon={<Info />} color="info">
                      Une intervalle de date que vous pensez être disponible de
                      nous joindre
                    </Alert>
                  }
                />
                <Grid m={3}>
                  <Grid
                    container
                    rowSpacing={3}
                    columnSpacing={{ xs: 5, md: 10 }}
                  >
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth>
                        <FormLabel>Date debut *</FormLabel>
                        <TextField
                          disabled={identif.toujours_dispo === "1"}
                          size="small"
                          type="date"
                          fullWidth
                          value={identif.date_dispo_debut}
                          onChange={(e) => {
                            setIdentif({
                              ...identif,
                              date_dispo_debut: e.target.value,
                            });
                          }}
                          error={formErrors.date_dispo_debut_error}
                          helperText={formErrors.date_dispo_debut_error}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth>
                        <FormLabel>Date fin *</FormLabel>
                        <TextField
                          size="small"
                          disabled={identif.toujours_dispo === "1"}
                          type="date"
                          fullWidth
                          value={identif.date_dispo_fin}
                          onChange={(e) => {
                            setIdentif({
                              ...identif,
                              date_dispo_fin: e.target.value,
                            });
                          }}
                          error={formErrors.date_dispo_fin_error}
                          helperText={formErrors.date_dispo_fin_error}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={identif.toujours_dispo === "1"}
                              onChange={(evt) => {
                                setIdentif({
                                  ...identif,
                                  date_dispo_debut: evt.target.checked
                                    ? ""
                                    : new Date().toISOString().slice(0, 10),
                                  date_dispo_fin: evt.target.checked
                                    ? ""
                                    : new Date(
                                        Date.now() + 30 * 24 * 60 * 60 * 1000
                                      )
                                        .toISOString()
                                        .slice(0, 10),
                                  toujours_dispo: evt.target.checked
                                    ? "1"
                                    : "0",
                                });
                              }}
                              name="tjr_dispo"
                            />
                          }
                          label="Je suis toujours disponible"
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container flexGrow={0.5}>
                <Divider variant="middle" sx={{ mt: 2 }} />
                {/* <CardHeader title={"Type de stage *"} /> */}
                <Grid container display={"flex"} flexDirection={"column"}>
                  <Grid
                    display={
                      ["Stagiaire"].includes(identif.poste) ? "" : "none"
                    }
                    item
                    fullWidth
                  >
                    <CardHeader title={"Type de stage *"} />
                    <FormControl
                      sx={{
                        m: 2,
                      }}
                      fullWidth
                    >
                      <FormLabel>
                        Quel type de stage voullez-vous chercher?
                      </FormLabel>
                      <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                          <Autocomplete
                            size="small"
                            fullWidth
                            disablePortal
                            options={TYPE_STAGE}
                            onChange={(evt, newValue) =>
                              setIdentif({
                                ...identif,
                                type_stage: newValue || "",
                              })
                            }
                            value={identif.type_stage || ""}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Type de stage"
                                error={formErrors.type_stage_error}
                                helperText={formErrors.type_stage_error}
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>
                    </FormControl>
                  </Grid>
                  <Grid>
                    <CardHeader title={"Choix de direction/antenne *"} />
                    <FormControl sx={{ m: 2 }}>
                      <FormLabel>
                        Dans quelle direction/antenne du FID souhaiterez-vous
                        joindre? *
                      </FormLabel>
                      <Grid item xs={12}>
                        <FormControl fullWidth>
                          <Autocomplete
                            size="small"
                            fullWidth
                            disablePortal
                            options={directionsFid}
                            onChange={(evt, newValue) =>
                              setIdentif({
                                ...identif,
                                direction_souhaiter: newValue || "",
                              })
                            }
                            value={identif.direction_souhaiter || ""}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Direction souhaitée"
                                error={formErrors.direction_souhaiter_error}
                                helperText={
                                  formErrors.direction_souhaiter_error
                                }
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Divider variant="middle" sx={{ mt: 2, mb: 2 }} />
          <Grid item m={3} display={"flex"} justifyContent={"space-between"}>
            <Button variant="outlined" onClick={handlePrevious}>
              Retour
            </Button>
            <LoadingButton
              loading={loading}
              variant="outlined"
              sx={{ marginLeft: "auto" }}
              onClick={() => handleSaveAll()}
              disabled={
                !Object.values(formErrors).every((item) => item === null)
              }
              color="primary"
            >
              Suivant
            </LoadingButton>
          </Grid>
          <Grid item mb={3}>
            <footer
              style={{
                color: "#0747a1",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              &copy; {new Date().getFullYear()} FID - FONDS D'INTERVENTION POUR LE DEVELOPPEMENT
            </footer>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Disponibilite;
